/* OTCD footer. Ported from mds/otcd-footer-reference.html. Loaded with defer by the otcd-footer-* sections. */
(function () {
  if (window.__otcdFooterLoaded) return; /* several sections may include this file */
  window.__otcdFooterLoaded = true;

  var MOBILE = window.matchMedia('(max-width: 749px)');
  var CALM = window.matchMedia('(prefers-reduced-motion: reduce)');

  function each(scope, selector, fn) {
    Array.prototype.forEach.call(scope.querySelectorAll(selector), fn);
  }

  /* ---- Vendor logo row ---- */
  function initVendors(scope) {
    each(scope, '[data-otcd-vendors]', function (view) {
      if (view.getAttribute('data-otcd-ready')) return;
      view.setAttribute('data-otcd-ready', 'true');
      var track = view.querySelector('.otcd-ft__vendors-track');
      var prev = view.querySelector('.otcd-ft__vendors-btn.is-prev');
      var next = view.querySelector('.otcd-ft__vendors-btn.is-next');
      if (!track || !prev || !next) return;

      function sync() {
        var max = track.scrollWidth - track.clientWidth;
        var canPrev = track.scrollLeft > 2;
        var canNext = track.scrollLeft < max - 2;
        var active = document.activeElement;
        prev.hidden = !canPrev;
        next.hidden = !canNext;
        if (active === next && !canNext && canPrev) prev.focus();
        if (active === prev && !canPrev && canNext) next.focus();
        view.classList.toggle('can-prev', canPrev);
        view.classList.toggle('can-next', canNext);
      }
      function step(dir) {
        track.scrollBy({ left: dir * Math.max(160, track.clientWidth * 0.8), behavior: CALM.matches ? 'auto' : 'smooth' });
      }
      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      window.addEventListener('load', sync);
      if (window.ResizeObserver) new ResizeObserver(sync).observe(track);
      if (window.MutationObserver) new MutationObserver(sync).observe(track, { childList: true });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync);
      sync();
    });
  }

  /* ---- Link columns: accordion on mobile, plain headings on desktop ---- */
  function setOpen(col, open) {
    var btn = col.querySelector('.otcd-ft__toggle');
    var list = col.querySelector('.otcd-ft__links');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (list) list.hidden = !open;
  }
  function applyColumns() {
    each(document, '.otcd-ft__col', function (col) {
      var heading = col.querySelector('.otcd-ft__h3');
      var list = col.querySelector('.otcd-ft__links');
      if (!heading || !list) return;
      var btn = heading.querySelector('.otcd-ft__toggle');
      if (MOBILE.matches) {
        if (!btn) {
          btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'otcd-ft__toggle';
          if (list.id) btn.setAttribute('aria-controls', list.id);
          btn.textContent = heading.textContent;
          heading.textContent = '';
          heading.appendChild(btn);
          btn.addEventListener('click', function () {
            setOpen(col, btn.getAttribute('aria-expanded') !== 'true');
          });
          col.classList.add('is-enhanced');
          setOpen(col, col.hasAttribute('data-open-mobile'));
        }
      } else {
        if (btn) {
          heading.textContent = btn.textContent;
          col.classList.remove('is-enhanced');
        }
        list.hidden = false;
      }
    });
  }

  /* ---- Newsletter: block the submit only when the email is bad ---- */
  function initNewsletter(scope) {
    each(scope, '[data-otcd-newsletter]', function (form) {
      if (form.getAttribute('data-otcd-ready')) return;
      form.setAttribute('data-otcd-ready', 'true');
      var input = form.querySelector('input[type="email"]');
      var msg = form.querySelector('.otcd-ft__msg');
      if (!input || !msg) return;
      form.addEventListener('submit', function (e) {
        var ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(input.value.trim());
        if (ok) { input.removeAttribute('aria-invalid'); return; }
        e.preventDefault();
        input.setAttribute('aria-invalid', 'true');
        msg.textContent = form.getAttribute('data-otcd-error') || 'Enter an email address like name@company.com.';
        input.focus();
      });
    });
  }

  function init(scope) {
    initVendors(scope);
    initNewsletter(scope);
    applyColumns();
  }

  init(document);
  if (MOBILE.addEventListener) MOBILE.addEventListener('change', applyColumns);
  else if (MOBILE.addListener) MOBILE.addListener(applyColumns);

  /* Theme editor: re-run when a section is added or re-rendered, and bring a selected logo into view */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target.closest ? e.target.closest('.otcd-ft__vendors-track li') : null;
    if (item) item.scrollIntoView({ block: 'nearest', inline: 'center' });
  });
})();
